const state = {
  user: 'Phoebe',  //用户名
  Jurisdiction: 0,         //权限
  token: "",       //token
  department: "",  //部门
  routeArr: [],  //路由路径
  xcxId: "",  //小程序id
  xcxUser: "",//小程序用户名
  xcxReal: "",  //小程序真名
  isLoading: false, //是否弹出loading
  isDinner:false, //是否dinner
  enter:"dinner", //默认登录页面的转入状态
  peopleC:false
}

export default state



// WEBPACK FOOTER //
// ./src/store/state.js